import * as S from './styles';

import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import Image, { StaticImageData } from 'next/image';
import { CSSProperties, Fragment, ReactNode } from 'react';

export type PaginaVendaTemplateProps = CheckoutContainerProps & {
  $bannerDestaqueImagem: string | StaticImageData;
  $styleBannerImage?: CSSProperties;
  $styleConteudoBannerInformativo?: CSSProperties;
  $breadcrumbPageTitle: string;
  $conteudoDescritivo?: ReactNode;
  $conteudoCheckout?: ReactNode;
  $produtoJaFoiAssinado?: boolean;
  $styleGradienteFundoBanner?: CSSProperties;
  $styleGradienteDireitaBanner?: CSSProperties;
};

import { Separator } from '@/components/atoms/Separator';
import CheckoutContainer, {
  CheckoutContainerProps,
} from '@/components/molecules/CheckoutContainer';
import BreadcrumbPagina from '@/components/molecules/BreadcrumbPagina';

export default function PaginaVendaDesktopTemplate(
  props: PaginaVendaTemplateProps,
) {
  const {
    $bannerDestaqueImagem,
    $styleConteudoBannerInformativo = {},
    $conteudoDescritivo,
    $conteudoCheckout,
    $valorTotal,
    $breadcrumbPageTitle,
    $funcaoAdicionarAoCarrinho,
    $funcaoAcaoPrincial,
    $textoBotaoAcaoPrincipal,
    $produtoJaFoiAssinado = false,
    $styleGradienteFundoBanner = undefined,
    $styleGradienteDireitaBanner = undefined,
  } = props;

  return (
    <S.Container>
      <BreadcrumbPagina $nomePaginaAtual={$breadcrumbPageTitle} />
      <S.ContainerContent
        style={{
          ...breakpointDesktopDefault,
          width: '100%',
          minHeight: '60vh',
        }}
      >
        <S.SideContainers>
          <S.ContainerBannerInformativo>
            <S.ContainerBannerImagem>
              <Image
                src={$bannerDestaqueImagem}
                alt="Banner principal"
                width={1920}
                height={600}
                style={{
                  objectFit: 'cover',
                }}
              />
              <Fragment>
                {$styleGradienteFundoBanner ? (
                  <S.GradienteFundo style={$styleGradienteFundoBanner} />
                ) : null}
                {$styleGradienteDireitaBanner ? (
                  <S.GradienteLateralDireita
                    style={$styleGradienteDireitaBanner}
                  />
                ) : null}
              </Fragment>
            </S.ContainerBannerImagem>
            <S.ContainerConteudoBannerInformativo
              style={$styleConteudoBannerInformativo}
            >
              {$conteudoDescritivo}
            </S.ContainerConteudoBannerInformativo>
          </S.ContainerBannerInformativo>
          <S.ContainerCheckoutEInformacoes>
            {$conteudoCheckout}
            <Separator $block={false} $orientation="horizontal" />
            <CheckoutContainer
              $valorTotal={$valorTotal}
              $funcaoAdicionarAoCarrinho={$funcaoAdicionarAoCarrinho}
              $funcaoAcaoPrincial={$funcaoAcaoPrincial}
              $textoBotaoAcaoPrincipal={$textoBotaoAcaoPrincipal}
              $permitirUsuarioRealizarCompra={
                !$produtoJaFoiAssinado && $valorTotal > 0
              }
            />
          </S.ContainerCheckoutEInformacoes>
        </S.SideContainers>
      </S.ContainerContent>
    </S.Container>
  );
}
